module.exports = __webpack_public_path__ + "img/analysis_everyday.8640a508.png";